import {DateTime} from "luxon";
import {TicketType} from './ticketType';

export class TicketEvent
{
    public id: number;
    public eventDate: DateTime;
    public name: string;
    public text: string;
    public bookingStart: DateTime;
    public ticketTypes: TicketType[];
    public location: string;
    public slug: string | null;
    
    public constructor(data: { [key: string]: any })
    {
        // const currentLocale = DateTime.local().resolvedLocaleOpts().locale;
        const currentLocale = 0 <= document.location.pathname.indexOf('/eng') ? 'en' : 'hu';

        this.id = data.id;
        this.eventDate = DateTime.fromISO(data.eventDate, { locale: currentLocale });
        this.name = data.name;
        this.text = data.text;
        this.bookingStart = DateTime.fromISO(data.bookingStart, { locale: currentLocale });
        this.ticketTypes = (data.ticketTypes as any[]).map(item => new TicketType(item));
        this.location = data.location;
        this.slug = data.slug;
    }
}